import { GridColDef } from '@mui/x-data-grid';
import { Box, IconButton, Tooltip } from '@mui/material';
import Icons from '../../../components/icons';
import { AcademicTerm } from '../types';

export const getAcademicTermColumns = (
  onEdit: (academicTerm: AcademicTerm) => void,
  onDelete: (academicTerm: AcademicTerm) => void
): GridColDef[] => {
  return [
    { field: 'name', headerName: 'Term Name', flex: 1 },
    { field: 'orderSequence', headerName: 'Order Sequence', flex: 1 },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Box>
          <Tooltip title='Edit'>
            <IconButton onClick={() => onEdit(params.row as AcademicTerm)}>
              <Icons.EditBlackOutlined />
            </IconButton>
          </Tooltip>
          <Tooltip title='Delete'>
            <IconButton onClick={() => onDelete(params.row as AcademicTerm)}>
              <Icons.Delete height={18} width={18} />
            </IconButton>
          </Tooltip>
        </Box>
      )
    }
  ];
};
